module.exports = __webpack_public_path__ + "img/badsensors_color.3256e22d.png";